import { cx } from '../../lib/cx';

export interface StepProgressProps {
  /** Total number of segments (the onboarding questionnaire has 5). */
  steps: number;
  /** 1-based current step; segments up to and including it are filled. */
  current: number;
  className?: string;
}

/** Figma onboarding progress: one rounded segment per step, brand-coloured once reached. */
export function StepProgress({ steps, current, className }: StepProgressProps) {
  const clamped = Math.min(steps, Math.max(0, current));
  return (
    <div
      role="progressbar"
      aria-label={`Step ${clamped} of ${steps}`}
      aria-valuemin={0}
      aria-valuemax={steps}
      aria-valuenow={clamped}
      className={cx('flex w-full gap-(--mbm-space-1-5)', className)}
    >
      {Array.from({ length: steps }, (_, i) => (
        <span
          key={i}
          className={cx(
            'h-(--mbm-space-1) flex-1 rounded-full transition-colors duration-(--mbm-duration-slow)',
            i < clamped ? 'bg-brand-primary' : 'bg-border-default',
          )}
        />
      ))}
    </div>
  );
}
